import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ViewAsService } from "../../shared/components/view-as/view-as.service";
import { AuthenticationService } from "../authentication/authentication.service";

@Injectable({
  providedIn: "root",
})
export class CompanyPartnerInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private viewAsService: ViewAsService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const { companyId, partnerId } = this.viewAsService.getViewAs() || {};
    const currentUser = this.authenticationService.currentUserInfo;
    const skipFilter = request.params.get("skipFilter");

    if (
      !skipFilter &&
      request.method === "GET" &&
      currentUser?.hasType(["global", "partner"]) &&
      (partnerId || companyId)
    ) {
      request = request.clone({
        setParams: {
          ...(partnerId && !companyId && { viewAsPartner: partnerId }),
          ...(!partnerId && companyId && { viewAsCompany: companyId }),
        },
      });
    }
    return next.handle(request);
  }
}
